export const THEMES = {
  light: 'light',
  semiLight: 'semi-light',
  dark: 'dark',
}